import { getApiKey } from "../../utils/apiKey";
import React, { useEffect, useState } from "react";
import Header from "../header";
import { createGlobalStyle } from "styled-components";
import axios from "axios";
import { apiCall_domain } from "../api";
//navigator.clipboard.writeText(copyText.value);

const InviteFriend = () => {
  const [state, setState] = useState({
    referralCode: "",
    referalLink: "",
  });
  const [show, setShow] = useState({
    link: false,
    code: false,
  });
  useEffect(() => {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/auth/share_code`, {
        headers: headers,
      })
      .then((res) => {
        const searchParam = new URLSearchParams(new URL(res.data).search);
        const referralCode = searchParam.get("referral_code");
        setState({
          referralCode: referralCode,
          referalLink: res.data,
        });
      });
  }, []);
  const GlobalStyles = createGlobalStyle`body{
      background: #FAFAFA !important;
    }`;
  const copyLink = () => {
    navigator.clipboard.writeText(state.referalLink);
    setShow({ link: true });
    setTimeout(() => {
      setShow({ link: false, code: false });
    }, 2000);
  };
  const copyCode = () => {
    navigator.clipboard.writeText(state.referralCode);
    setShow({ code: true });
    setTimeout(() => {
      setShow({ link: false, code: false });
    }, 2000);
  };
  return (
    <>
      <GlobalStyles />
      <Header
        showSearchBar={true}
        title={"دعوت از دوستان"}
        backUrl={"/profile"}
      />
      <main className="InviteFriend">
        <p>دوستانتو به کاچار دعوت کن و امتیاز دریافت کن</p>
        <p>با دعوت هر دوست ۵۰ امتیاز کسب کنید</p>
        <div className="InviteFriendContent">
          <span>کد دعوت شما</span>
          <div className="referralCode">
            <span id="mySpan">{state.referralCode}</span>
            <img
              onClick={() => copyCode()}
              src="/public/assets/icons/Group 1000001182.svg"
              alt="imgcopy"
            />
          </div>
        </div>
        <div className="InviteFriendContent">
          <span>لینک دعوت شما</span>
          <div className="referralCode">
            <span id="mySpan">لینک دعوت</span>
            <img
              onClick={() => copyLink()}
              src="/public/assets/icons/Group 1000001182.svg"
              alt="imgcopy"
            />
          </div>
          <div className="copyReminderContent">
            <div className={`copyReminder ${show.link && "showCopy"}`}>
              لینک ذخیره شد
            </div>
            <div className={`copyReminder ${show.code && "showCopy"}`}>
              کد ذخیره شد
            </div>
          </div>
        </div>
        <div className="InviteImage">
          <img src="/public/assets/icons/banerinvite.svg" alt="Invite" />
        </div>
      </main>
    </>
  );
};

export default InviteFriend;
